"use client";
import { Chip, Stack, useTheme } from "@mui/material";
import { useCommentsStore } from "@/stores/commentsStore";
import { safeT } from "@/utils/safeT";
import { useTranslations } from "next-intl";

export default function SortOptions() {
  const { sortOption, setSortOption } = useCommentsStore();
  const t = useTranslations();
  const theme = useTheme();
  return (
    <Stack direction="row" spacing={1} mb={2}>
      <Chip
        label={safeT(t, "ui.label.popular", {
          defaultMessage: "인기순",
        })}
        onClick={() => setSortOption("popular")}
        sx={{
          cursor: "pointer",
          maxWidth: 150,
          fontWeight: 600,
          textAlign: "center",
          whiteSpace: "nowrap",
          borderRadius: "50px",
          transition: "all 0.3s ease",
          backgroundColor:
            sortOption === "popular"
              ? theme.palette.primary.main
              : theme.palette.mode === "dark"
              ? theme.palette.grey[800] // 다크 모드 배경색
              : theme.palette.grey[300], // 라이트 모드 배경색
          color:
            sortOption === "popular"
              ? theme.palette.primary.contrastText
              : theme.palette.mode === "dark"
              ? theme.palette.grey[300] // 다크 모드 글자색
              : theme.palette.grey[900], // 라이트 모드 글자색
          "&:hover": {
            backgroundColor:
              sortOption === "popular"
                ? theme.palette.primary.dark
                : theme.palette.mode === "dark"
                ? theme.palette.grey[700]
                : theme.palette.grey[400],
          },
        }}
      />
      <Chip
        label={safeT(t, "ui.label.recent", {
          defaultMessage: "최신순",
        })}
        onClick={() => setSortOption("latest")}
        sx={{
          cursor: "pointer",
          maxWidth: 150,
          fontWeight: 600,
          textAlign: "center",
          whiteSpace: "nowrap",
          borderRadius: "50px",
          transition: "all 0.3s ease",
          backgroundColor:
            sortOption === "latest"
              ? theme.palette.primary.main
              : theme.palette.mode === "dark"
              ? theme.palette.grey[800] // 다크 모드 배경색
              : theme.palette.grey[300], // 라이트 모드 배경색
          color:
            sortOption === "latest"
              ? theme.palette.primary.contrastText
              : theme.palette.mode === "dark"
              ? theme.palette.grey[300] // 다크 모드 글자색
              : theme.palette.grey[900], // 라이트 모드 글자색
          "&:hover": {
            backgroundColor:
              sortOption === "latest"
                ? theme.palette.primary.dark
                : theme.palette.mode === "dark"
                ? theme.palette.grey[700]
                : theme.palette.grey[400],
          },
        }}
      />
    </Stack>
  );
}
